import React, { Component, useState } from 'react';
import {
    MDBNavbar, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBCollapse, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem,
    MDBHamburgerToggler
} from 'mdbreact';
import { BrowserRouter as Router, Link, Switch } from 'react-router-dom';

const MobileMenuGlobal = () => {
    const [state, setState] = useState({
        collapse1: false,
        collapseID: ''
    })

    const toggleCollapse = collapseID => () => {
        setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
    }

    const toggleSingleCollapse = collapseId => {
        setState({
            ...state,
            [collapseId]: !state[collapseId]
        });
    }

    return (
        <Router>
            <Switch>
                <MDBNavbar>
                    <MDBHamburgerToggler id="hamburger1" onClick={() => toggleSingleCollapse('collapse1')} />
                    <MDBCollapse isOpen={state.collapse1} navbar>
                        <MDBNavbarNav left>
                            <MDBNavItem active>
                                <MDBNavLink to="/" onClick={() => window.location.replace('/')}>Utama</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/data" onClick={() => window.location.replace('/data')}>Data</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/organisasi" onClick={() => window.location.replace('/organisasi')}>Organisasi</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/kategori" onClick={() => window.location.replace('/kategori')}>Kategori</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/info-grafis" onClick={() => window.location.replace('/info-grafis')}>Info Grafis</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/kritik-saran" onClick={() => window.location.replace('/kritik-saran')}>Kritik & Saran</MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink to="/tentang" onClick={() => window.location.replace('http://geoportal.mubakab.go.id')}>Geo Portal</MDBNavLink>
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBNavbar>
            </Switch>
        </Router>
    );
}
export default MobileMenuGlobal;